import { IElementCategory } from '../../../models/element-categories.model';
import { ElementPropertyType } from '../../../models/element-property.model';
import { ArrayItem } from '../../../models/type-helpers.model';
import { commonElementCategoryProperties } from '../common-element-category-properties.model';
import { reusedContentProperty } from '../reused-content-property.model';
import {
  CeramicsForm,
  CeramicsProcessing,
  CeramicsMaterial,
  CeramicsCementAmount,
  CeramicsPropertyName,
} from './ceramics.model';

const expandedClayConcreteProperties: ArrayItem<
  IElementCategory['properties']
> = {
  conditions: {
    [CeramicsPropertyName.Material]: CeramicsMaterial.ExpandedClayConcrete,
  },
  nodes: [
    {
      name: CeramicsPropertyName.CementAmount,
      type: ElementPropertyType.Select,
      options: Object.values(CeramicsCementAmount),
      indentation: 1,
    },
  ],
};

const clayProperties: ArrayItem<IElementCategory['properties']> = {
  conditions: {
    [CeramicsPropertyName.Material]: CeramicsMaterial.Clay,
  },
  nodes: [
    {
      name: CeramicsPropertyName.Processing,
      type: ElementPropertyType.Select,
      options: Object.values(CeramicsProcessing),
      indentation: 1,
    },
  ],
};

const brickAndBlocksProperties: ArrayItem<IElementCategory['properties']> = {
  conditions: {
    [CeramicsPropertyName.Form]: CeramicsForm.BricksAndBlocks,
  },
  nodes: [
    {
      name: CeramicsPropertyName.Material,
      type: ElementPropertyType.Select,
      options: Object.values(CeramicsMaterial),
      indentation: 1,
    },
    clayProperties,
    expandedClayConcreteProperties,
  ],
};

export const ceramicsProperties: IElementCategory['properties'] = [
  {
    name: CeramicsPropertyName.Form,
    type: ElementPropertyType.Select,
    options: Object.values(CeramicsForm),
  },
  brickAndBlocksProperties,
  reusedContentProperty,
  ...commonElementCategoryProperties,
];
